var render, staticRenderFns
import script from "./LinkedForm.vue?vue&type=script&lang=ts&"
export * from "./LinkedForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7eb440",
  null
  
)

export default component.exports